import { render } from "./EsportaSottoprogetto.vue?vue&type=template&id=7afc4599&ts=true"
import script from "./EsportaSottoprogetto.vue?vue&type=script&lang=ts"
export * from "./EsportaSottoprogetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__